import { FlexRow } from '@/components/common/Flex';
import { AlertCircle } from '@/components/common/icons';
import { toDollarsWithCents } from '@/util/currency';
import { Divider } from '@chakra-ui/react';
import { TransactionScheduleFieldsFragment } from '@common/graphql/generated';
import {
    GoalDirection,
    isFailedTransactionStatus,
    TransactionProps,
} from '@common/react/transactions';
import { getTransactionSummaryProps } from '@common/react/transactions/getTransactionSummaryProps';
import { FlexCol } from '../common/Flex';
import { Subheader, Title } from '../common/Typography';

export type GoalTransactionStatusHeaderProps = {
    transaction: TransactionProps;
    goalDirection: GoalDirection;
    transactionSchedule?: TransactionScheduleFieldsFragment;
    titleRight?: React.ReactNode;
};

const GoalTransactionStatusHeader = ({
    transaction,
    transactionSchedule,
    goalDirection,
    titleRight,
}: GoalTransactionStatusHeaderProps) => {
    const isFailed = isFailedTransactionStatus(transaction.status);

    const { title, subtitle } = getTransactionSummaryProps({
        transaction,
        transactionSchedule,
        goalDirection,
    });

    return (
        <>
            <FlexRow justify="space-between" gap={4} align="flex-end">
                <FlexCol>
                    <FlexRow align="center" mb={1}>
                        <Title>{toDollarsWithCents(transaction.amount)}</Title>
                        {isFailed && (
                            <AlertCircle color="red.500" size="md" ml={2} />
                        )}
                    </FlexRow>
                    <Subheader>{title}</Subheader>
                    {subtitle && (
                        <FlexCol
                            gap={3}
                            mt={4}
                            fontSize="md"
                            fontWeight="normal"
                            color="textMuted"
                        >
                            {subtitle}
                        </FlexCol>
                    )}
                </FlexCol>
                {titleRight}
            </FlexRow>

            <Divider mt={6} />
        </>
    );
};

export default GoalTransactionStatusHeader;
